import React, { useState } from 'react';
import axios from 'axios';

const SearchBar = ({ setWeatherData }) => {
    const [city, setCity] = useState('');
    const handleInputChange = (event) => {
        setCity(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        axios.get(`https://uchennasporfolio-e180324e16c1.herokuapp.com/weatherapp/?city=${city}`)
            .then(response => {
                // Handle the response
                setWeatherData(response.data);
                console.log({city},response.data);
            })
            .catch(error => {
                // Handle the error
                console.error('There was an error!', error);
            });
    };

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                placeholder="Enter a city"
                value={city}
                onChange={handleInputChange}
            />
            <button type="submit">Submit</button>
        </form>
    );
};

export default SearchBar;
